import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IEmailNotificationsPanelButtonProps } from './types';
import { BOARD_SECTION_EMAIL_NOTIFICATIONS } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function EmailNotificationsPanelButton ({
    indicatorBoolean,
    tooltip,
    onClick
}: IEmailNotificationsPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.EMAIL_NOTIFICATIONS}
            indicatorBoolean={indicatorBoolean}
            title={BOARD_SECTION_EMAIL_NOTIFICATIONS}
            tooltip={tooltip}
            onClick={() => {
                setSubTab(EBoardSetting.EMAIL_NOTIFICATIONS);
                onClick();
            }}
        />
    );
}
